<template>
  <div id="teachercommunications">
    <v-chip-group
      v-if="syncedCommunicationTopicArray?.length > 0"
      v-model="selectedTopicIds"
      multiple
      column
      class="px-3"
      @change="changeCommunicationTopics"
    >
      <v-chip
        v-for="topic in syncedCommunicationTopicArray"
        :key="topic.id"
        :value="topic.id"
        :color="selectedTopicIds?.includes(topic.id) ? 'primary' : 'secondary'"
      >
        {{ topic.title }}
      </v-chip>
    </v-chip-group>

    <div
      v-if="
        filteredCommunications?.length === 0 && communicationSubscriptionQueried
      "
      class="d-flex justify-center pa-3"
    >
      No communications currently found for the selected topics
    </div>

    <div class="px-3">
      <masonry
        :gutter="{ default: '16px', 700: '16px' }"
        :cols="{ default: 3, 1000: 3, 700: 2, 500: 1 }"
      >
        <CommunicationCard
          v-for="(communication, index) in filteredCommunications"
          :key="'communication-' + index"
          :body="communication.body"
          :subject="communication.subject"
          :videoSrc="communication.video"
          :images="communication.images"
          :show="communication.show"
          :countDownTo="communication.countDownTo"
          :listItems="communication.listItems"
          :outlined="true"
        ></CommunicationCard>
      </masonry>
    </div>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="overflow-x-hidden overflow-y-auto pa-3" max-height="90vh">
        <v-form ref="form">
          <v-card-title>
            <span class="text-h5"
              >{{ $i18n.t("actions.view") + " " + $i18n.t("headings.order") }}
              <!-- <helper topic="classesedit" /> -->
            </span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12"> </v-col>
            </v-row>
          </v-card-text>

          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close">
              {{ $i18n.t("actions.close") }}
            </v-btn>
          </v-card-actions> -->
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import { DataStore, SortDirection, Predicates, API } from "aws-amplify";
import { Communication, CommunicationTopic } from "@/models";
import { updateTeacherProfile } from "@/graphql/mutations";
import CommunicationCard from "@/components/global-components/CommunicationCard.vue";
// import Helper from "@/components/global-components/Helper.vue";
import store from "@/store";

export default {
  name: "TeacherCommunications",
  components: {
    // Helper,
    CommunicationCard,
  },
  data: () => ({
    initiallyLoaded: false,
    dialog: false,
    editedItem: {},
    defaultItem: {},

    syncedCommunicationArray: [],
    communicationSubscription: null,
    communicationSubscriptionQueried: false,

    syncedCommunicationTopicArray: [],
    communicationTopicSubscriptionSynced: false,
    selectedTopicIds: [],
    changedSelectedTopics: false,

    oldTeacherProfileModelVersion: 0,
  }),

  computed: {
    filteredCommunications() {
      if (!this.selectedTopicIds.length) {
        return this.syncedCommunicationArray;
      }
      return this.syncedCommunicationArray.filter((comm) => {
        if (!comm.topics) return false;
        let topicIds = comm.topics;
        if (!Array.isArray(topicIds)) return false;
        return this.selectedTopicIds.some((id) => topicIds.includes(id));
      });
    },

    ...mapState({
      offline: (state) => !state.isOnline,
      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,
      syncedTeacherProfile: (state) => state.syncedTeacherProfile,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
    }),
  },

  async mounted() {
    try {
      document.addEventListener(
        "queryCommunications",
        this.queryCommunications,
      );
      // await this.queryCommunications();
    } catch (error) {
      console.log(error);
    }
    // finally {
    //   if (!this.initiallyLoaded) {
    //     this.initiallyLoaded = true;
    //   }
    // }
  },

  watch: {
    syncedTeacherProfile: {
      async handler(val) {
        console.log("syncedTeacherProfile", val);
        if (val && this.changedSelectedTopics) {
          await API.graphql({
            query: updateTeacherProfile,
            variables: {
              input: {
                id: this.syncedTeacherProfileModel.id,
                _version: this.syncedTeacherProfileModel._version,
                communicationTopics: JSON.stringify([
                  ...new Set(this.selectedTopicIds),
                ]),
              },
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          // await DataStore.save(
          //   TeacherProfile.copyOf(
          //     this.syncedTeacherProfileModel,
          //     (updatedModel) => {
          //       updatedModel.communicationTopics = [...new Set(this.selectedTopicIds)]
          //     }
          //   )
          // );
          this.changedSelectedTopics = false;
        }
      },
    },

    dialog(val) {
      val || this.close();
    },

    syncedTeacherProfileModel: {
      async handler(newVal) {
        if (newVal?.id) {
          if (!this.initiallyLoaded && !this.changingDatastoreConfig) {
            this.syncCommunicationTopics();
            await this.queryCommunications();
            this.initiallyLoaded = true;
          }

          const teacherProfiletopics = newVal.communicationTopics;
          if (
            !this.changedSelectedTopics &&
            Array.isArray(teacherProfiletopics) &&
            !_.isEqual(this.selectedTopicIds, teacherProfiletopics)
          ) {
            console.log("teacherProfiletopics", teacherProfiletopics);
            this.selectedTopicIds = [...new Set(teacherProfiletopics)];
          }
        }
      },
      immediate: true,
      deep: true,
    },

    changingDatastoreConfig: {
      async handler(newVal, oldVal) {
        // console.log("watch changingDatastoreConfig", newVal, oldVal);

        if (newVal === true) {
          return;
        }

        if (
          newVal === false &&
          this.syncedTeacherProfileModel?.id &&
          !this.initiallyLoaded
        ) {
          this.syncCommunicationTopics();
          await this.queryCommunications();
          this.initiallyLoaded = true;
        }
      },
    },
  },

  methods: {
    changeCommunicationTopics: _.debounce(async function (value) {
      console.log("changeCommunicationTopics value", value);
      try {
        if (!this.syncedTeacherProfileModel) {
          return;
        }

        if (this.syncedTeacherProfile) {
          await API.graphql({
            query: updateTeacherProfile,
            variables: {
              input: {
                id: this.syncedTeacherProfileModel.id,
                _version: this.syncedTeacherProfileModel._version,
                communicationTopics: JSON.stringify([...new Set(value)]),
              },
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          // await DataStore.save(
          //   TeacherProfile.copyOf(
          //     this.syncedTeacherProfileModel,
          //     (updatedModel) => {
          //       updatedModel.communicationTopics = [...new Set(value)];
          //     },
          //   ),
          // );
          this.changedSelectedTopics = false;
        } else {
          this.changedSelectedTopics = true;
        }
      } catch (error) {
        console.error(error);
      }
    }, 1500),

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },

    viewItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    async queryCommunications() {
      try {
        const validGrades =
          this.syncedTeacherProfileModel?.payfastSubscriptionPackage?.grades ||
          [];
        // console.log("validGrades: ", validGrades);

        // this.communicationSubscription = DataStore.observeQuery(
        //   Communication
        //   // (comunication) =>
        //   // comunication.or((comunication) => [
        //   // comunication.or((c) =>
        //   //   (grades ? grades : []).map((grade) => c.sendTo("contains", 6))
        //   // )
        //   // comunication.sendTo("contains", "ALL"),
        //   // ])
        // ).subscribe(
        //   async (snapshot) => {
        //     const { items, isSynced } = snapshot;
        //     if (isSynced && items && this.syncedCommunicationArray !== items) {
        //       this.syncedCommunicationArray = items;

        //       console.log("Communications synced: ", items);

        //       this.communicationSubscriptionSynced = true;
        //     }
        //   },
        //   (error) => {
        //     console.log(error);
        //     this.communicationSubscriptionSynced = true;
        //   }
        // );

        // const search = this.productsSearch.split(" ");

        const currentDateTime = new Date().toISOString();

        const queriedCommunications = await DataStore.query(
          Communication,
          (communication) =>
            communication.and((c) => [
              // c.or((c) => [
              //   c.eCommerceProduct("eq", true),
              //   c.subscriptionProduct("eq", true),
              // ]),
              // c.thumbnails("gt", []),
              communication.publishDate("lt", currentDateTime),
              communication.or((communication) => [
                communication.sendTo("contains", "ALL"),
                communication.sendTo("contains", "General"),
                communication.or((c) =>
                  validGrades.map((grade) => c.sendTo("contains", grade)),
                ),
              ]),
            ]),
          {
            // limit: this.limit,
            sort: (s) =>
              s
                .publishDate(SortDirection.DESCENDING)
                .subject(SortDirection.DESCENDING),
          },
        );

        this.syncedCommunicationArray = queriedCommunications;

        // console.log("queriedCommunications", queriedCommunications);
      } catch (error) {
        console.log(error);
      } finally {
        this.communicationSubscriptionQueried = true;
      }
    },

    async syncCommunicationTopics() {
      try {
        const communicationTopicSubscription = DataStore.observeQuery(
          CommunicationTopic,
          Predicates.ALL,
          {
            sort: (s) => s.title(SortDirection.ASCENDING),
          },
        ).subscribe(
          (snapshot) => {
            const { items, isSynced } = snapshot;
            if (
              isSynced &&
              items &&
              this.syncedCommunicationTopicArray !== items
            ) {
              this.syncedCommunicationTopicArray = items;
              this.communicationTopicSubscriptionSynced = true;
            }
          },
          (error) => {
            console.log(error);
            this.communicationTopicSubscriptionSynced = true;
          },
        );

        store.commit("addSubscription", {
          model: "CommunicationTopic",
          sub: communicationTopicSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener(
      "queryCommunications",
      this.queryCommunications,
    );
    if (this.communicationSubscription) {
      this.communicationSubscription.unsubscribe();
    }
  },
};
</script>
